<template>
  <div class="addre">
    <headd></headd>

    <div class="recharge container">
      <div class="re_title">充值金额</div>
      <div class="re_input">
        <div class="icon">￥</div>
        <input
          class="input"
          v-model="info.recharge_price"
          @input="gorecharge"
          type="number"
          min="1"
          placeholder="请输入您要充值的金额"
        />
      </div>
      <div class="re_type">
        <div
          class="item_type"
          :class="{ active: isChange == index }"
          v-for="(item, index) in price_list"
          :key="index"
          @click="selecttype"
          :data-index="index"
          :data-price="item.price"
        >
          {{ item.price }}元
        </div>
      </div>
      <div class="info">
        <div class="name">请选择支付方式</div>
        <div class="pay_type">
          <div
            class="type_item"
            v-for="(item, index) in items"
            :key="item.value"
          >
            <div class="type_name">
              <div class="type_icon">
                <img
                  :src="'../../../../static/order/pay_' + item.value + '.png'"
                />
              </div>
              {{ item.name }}
            </div>
            <div>
              <input
                class="radio"
                type="radio"
                id="type"
                :value="item.value"
                :checked="index === current"
                v-model="paytype"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="btn_save_red" @click="payorder">立即充值</div>
    </div>
    <foot></foot>

    <el-dialog
      :visible.sync="dialogFormVisible"
      width="6rem"
      :before-close="handleClose"
    >
      <div class="code_con">
        <div class="qr_tip">
          <span>使用微信扫码支付</span>
        </div>
        <div id="qrCode" ref="qrCodeDiv"></div>
        <div class="qr_btn" @click="qr_btn">完成</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getrechargepayment } from "../../api/api"; //引入api里面定义的方法
import headd from "@/components/head";
import foot from "@/components/foot";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      dialogFormVisible: false,
      price_list: [
        {
          id: 1,
          price: 5000
        },
        {
          id: 2,
          price: 2000
        },
        {
          id: 3,
          price: 1000
        },
        {
          id: 4,
          price: 500
        },
        {
          id: 5,
          price: 200
        },
        {
          id: 6,
          price: 100
        },
        {
          id: 7,
          price: 50
        },
        {
          id: 8,
          price: 40
        },
        {
          id: 9,
          price: 20
        },
        {
          id: 10,
          price: 10
        }
      ],
      items: [],

      type: ["alipay", "wxpcpay"],
      current: 0,
      info: {
        recharge_price: 0
      },
      isChange: -1,
      paytype: "1",
      mobile: false
    };
  },
  computed: {
    Newinfo() {
      return JSON.parse(JSON.stringify(this.info));
    }
  },
  components: {
    headd,
    foot
  },
  watch: {
    Newinfo: {
      handler(newVal, oldVal) {
        if (newVal.recharge_price == "") {
          //console.log(23);
          this.isChange = -1;
        }
      },
      deep: true //深度监听(可监听到对象、数组的变化)
    }
  },
  mounted() {
    if (this.isWeiXin()) {
      this.items = [
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "2";
      this.mobile = true;
    } else {
      this.items = [
        {
          value: "1",
          name: "支付宝"
        },
        {
          value: "2",
          name: "微信"
        }
      ];
      this.paytype = "1";
      this.mobile = false;
    }
  },

  methods: {
    //判断是否是微信浏览器的函数
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      //alert(JSON.stringify(ua));
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    handleClose() {
      console.log(123);
      this.dialogFormVisible = false;
      document.getElementById("qrCode").innerHTML = "";
    },
    qr_btn() {
      this.$router.push({
        name: "rechargelist"
      });
    },
    gorecharge(e) {
      var that = this;
      that.recharge_price = e.detail.value;
    },

    payorder() {
      var _self = this;
      if (_self.info.recharge_price == 0) {
        this.$toast("请输入充值金额");
        return false;
      }
      if (_self.info.recharge_price < 0) {
        this.$toast("充值金额必须大于0");
        return false;
      }
      if (_self.type[_self.paytype - 1] == "alipay") {
        //支付宝支付
        var parm = [
          {
            name: "uid",
            value: localStorage.getItem("userId")
          },
          {
            name: "recharge_price",
            value: _self.info.recharge_price
          },
          {
            name: "pay_type",
            value: "alipay"
          },
          {
            name: "sessionToken",
            value: localStorage.getItem("sessionToken")
          }
        ];

        //模拟form表单
        var temp_form = document.createElement("form");
        temp_form.action =
          "https://mscyeserver.mscye.com/webstf.php/webStfapi/rechargepayment";
        //如需打开新窗口，form的target属性要设置为'_blank'
        temp_form.target = "_self";
        temp_form.method = "post";
        temp_form.style.display = "none";
        //添加参数
        for (var item in parm) {
          var opt = document.createElement("textarea");
          //console.log(parm[item].name);
          opt.name = parm[item].name;
          opt.value = parm[item].value;
          temp_form.appendChild(opt);
        }
        document.body.appendChild(temp_form);
        //提交数据
        temp_form.submit();

        _self.info.recharge_price = 0;
      } else if (_self.type[_self.paytype - 1] == "wxpcpay") {
        if (_self.mobile) {
          var parm = {
            uid: localStorage.getItem("userId"),
            openid: localStorage.getItem("openid"),
            recharge_price: _self.info.recharge_price,
            pay_type: "wxjspay"
          };
          _self.pay_weixin_mobile(parm);
        } else {
          var parm = {
            uid: localStorage.getItem("userId"),

            recharge_price: _self.info.recharge_price,
            pay_type: "wxpcpay"
          };
          _self.pay_weixin(parm);
        }
      }

      //_self.pay(parm);
    },

    async pay_weixin(parm) {
      var _self = this;
      const res = await getrechargepayment(parm);
      console.log(JSON.parse(res.data.payStr).code_url);
      _self.dialogFormVisible = true;
      _self.$nextTick(function() {
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: JSON.parse(res.data.payStr).code_url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },

    async pay_weixin_mobile(parm) {
      var _self = this;
      const res = await getrechargepayment(parm);
      var data = JSON.parse(res.data.payStr);
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
      } else {
        _self.onBridgeReady(data);
      }
    },
    onBridgeReady(data) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: "" + data.appId,
          timeStamp: "" + data.timeStamp,
          nonceStr: "" + data.nonceStr,
          package: "" + data.package,
          signType: "" + data.signType,
          paySign: "" + data.paySign
        },
        function(res) {
          console.log(res);
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            this.$router.push({
              path: "rechargelist"
            });
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          }
        }
      );
    },

    selecttype(e) {
      console.log(e);
      var _slef = this;
      var index = e.currentTarget.dataset.index;
      var price = e.currentTarget.dataset.price;
      if (index != this.isChange) {
        this.isChange = index;
        _slef.info.recharge_price = price;
      } else {
        this.isChange = -1; //不注释则可以点击取消，注释之后点击就不再取消
        _slef.otheroption = "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.addre {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: auto;
  }
}
.recharge {
  margin: 0.32rem auto;
  width: 8rem;
  @media (max-width: 991px) {
    width: 100%;
    padding: 0;
  }
  flex-direction: column;
  text-align: left;
  .re_title {
    font-size: 0.24rem;
    color: #1b1c33;
    padding: 0;
    @media (max-width: 991px) {
      font-size: 0.32rem;
      line-height: 0.42rem;
    }
  }

  .re_input {
    align-items: center;
    padding: 0.23rem 0.32rem;
    display: flex;

    .icon {
      font-size: 0.3rem;
      color: #1b1c33;
      margin-right: 0.1rem;
    }

    .input {
      font-size: 0.3rem;
      color: #1b1c33;
      border: 0.01rem solid #ccc;
      padding: 0.05rem 0.1rem;
    }
  }

  .re_type {
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0.2rem 0;
    border-top: 0.01rem solid rgba(196, 196, 204, 0.5);
    border-bottom: 0.01rem solid rgba(196, 196, 204, 0.5);
    display: flex;

    .item_type {
      cursor: pointer;
      width: auto;
      margin: 0.1rem;
      background: rgba(196, 196, 204, 0.2);
      border-radius: 0.12rem;
      text-align: center;
      justify-content: center;
      font-size: 0.24rem;
      line-height: 0.5rem;
      height: 0.5rem;
      padding: 0rem 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.28rem;
      }
      &:nth-child(3n + 0) {
        margin-bottom: 0;
      }
    }

    .item_type.active {
      background: #1395ff;
      color: #fff;
    }
  }

  .info {
    flex-direction: column;
    width: ~"calc(100% - 64rpx)";
    padding: 0.3rem 0.32rem;
    // border-bottom: 1rpx solid rgba(196, 196, 204, 0.5);

    .name {
      font-size: 0.24rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.24rem;
      margin-bottom: 0.2rem;
      margin-top: 0.2rem;
      @media (max-width: 991px) {
        font-size: 0.32rem;
        line-height: 0.42rem;
      }
    }

    .option {
      flex-direction: row;
      margin-bottom: 0.2rem;

      .title {
        font-size: 0.26rem;
        color: #1b1c33;
        line-height: 0.37rem;
        width: 1.3rem;
      }

      .content {
        width: 5rem;
        flex-direction: column;
        font-size: 2.6rem;
        color: #444649;
        line-height: 0.37rem;

        view {
          margin-bottom: 0.15rem;
          flex-direction: row;

          &:last-child {
            margin-bottom: 0;
          }

          .red {
            color: rgba(255, 84, 90, 1);
          }

          .status {
            margin-left: 0.32rem;
            font-weight: bolder;
            color: #1395ff;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    .price {
      margin-top: 0.21rem;
      font-size: 0.3rem;
      font-weight: bolder;
      color: #1b1c33;
      line-height: 0.42rem;
      letter-spacing: 0.01rem;

      .span {
        color: #ff545a;
      }
    }

    .pay_type {
      width: 100%;

      radio-group {
        width: 100%;
      }

      .type_item {
        justify-content: space-between;
        width: 100%;
        align-items: center;
        margin-bottom: 0.4rem;
        display: flex;

        .type_name {
          font-size: 0.2rem;
          color: #1b1c33;
          display: flex;
          align-items: center;
          @media (max-width: 991px) {
            font-size: 0.28rem;
          }

          .type_icon {
            width: 0.4rem;
            height: 0.4rem;
            margin-right: 0.2rem;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .radio {
          width: 0.3rem;
          height: 0.3rem;
        }
      }
    }

    .btn_list {
      width: 100%;
      justify-content: space-between;
      margin-top: 0.2rem;

      .btn {
        width: 3.09rem;
        height: 0.8rem;
        font-size: 0.36rem;
        color: #ffffff;
        line-height: 0.8rem;
        letter-spacing: 0.02rem;
        text-align: center;
        justify-content: center;
        align-items: center;
      }

      .btn.kefu {
        background: url(../../../../static/order/btn_1.png) no-repeat;
        background-size: 3.09rem 0.8rem;
      }

      .btn.buy {
        background: url(../../../../static/order/btn_2.png) no-repeat;
        background-size: 3.09rem 0.8rem;
      }
    }
  }
}
.code_con {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .qr_tip {
    font-size: 0.16rem;
    line-height: 0.25rem;
    text-align: center;
    @media (max-width: 991px) {
      font-size: 0.26rem;
      line-height: 0.33rem;
    }
  }
  .qr_btn {
    margin-top: 0.2rem;
    width: 1.26rem;
    height: 0.4rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    background-color: #1395ff;
    border-radius: 0.2rem;
    color: #ffffff;
    text-align: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/recharge/recharge.vue